import React from "react";
import { TitleInputWithDefault } from "../../utils/TitleInputWithDefault";
import { ConfigForm_SectionWrapper } from "../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { WidgetHeader } from "../../WidgetBarChart/WIDGET_ELEM_ConfigForm";
import { LineChartConfigProvider } from "./ConfigForm_Context";
import { ConfigForm_DataSection } from "./ConfigForm_DataSection";
import { ConfigForm_BreakdownSection, BreakdownAddFieldButton } from "./ConfigForm_BreakdownSection";
import { ConfigForm_FiltersSection } from "./ConfigForm_FiltersSection";
import { DATA_KEYS } from "./DATA_KEYS";
import { useWidgetFilterControls } from "../../utils/useWidgetFilterControls";
import { getWidgetHasDimensions } from "../../utils/getWidgetContentTypes";

export const LineChartConfigForm = ({
  thisWidgetConfig,
  setConfig,
  underEditWidgetIdx,
  widgetIcon,
  widgetTitle,
}) => {
  const widgetType = thisWidgetConfig?.comp || 'WidgetLineChart';
  const hasDimensions = getWidgetHasDimensions(thisWidgetConfig, widgetType);
  const { filterHeaderProps, filterControlProps } = useWidgetFilterControls({
    hasDimensions
  });

  return (
    <LineChartConfigProvider
      thisWidgetConfig={thisWidgetConfig}
      setConfig={setConfig}
      underEditWidgetIdx={underEditWidgetIdx}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.4rem' }}>
        <WidgetHeader title={widgetTitle} type="Chart" icon={widgetIcon} />
        <ConfigForm_SectionWrapper>
          <TitleInputWithDefault
            widgetConfig={thisWidgetConfig}
            widgetType="WidgetLineChart"
            setConfig={setConfig}
            underEditWidgetIdx={underEditWidgetIdx}
            titlePath={DATA_KEYS.field1}
            tagLabel="WIDGET TITLE"
            placeholder="Update custom label"
          />
        </ConfigForm_SectionWrapper>

        <ConfigForm_SectionWrapper icon="CalendarBlank" title="Time Series Data">
          <ConfigForm_DataSection />
        </ConfigForm_SectionWrapper>

        <ConfigForm_SectionWrapper icon="Flask" title="Breakdown" headerRight={<BreakdownAddFieldButton />}>
          <ConfigForm_BreakdownSection />
        </ConfigForm_SectionWrapper>

        <ConfigForm_SectionWrapper
          icon="Funnel"
          title="Filters"
          {...filterHeaderProps}
        >
          <ConfigForm_FiltersSection {...filterControlProps} />
        </ConfigForm_SectionWrapper>
      </div>
    </LineChartConfigProvider>
  );
};
